import React from 'react';
import SchedulePage from '../schedule/SchedulePage';
import { TYPE_OPTIONS, typeLabel, typeOf } from './programmeModel';

// Operative programme (Firestore collection "files"), prepared by the secretaries.
const PROGRAMME = {
  collection: 'files',
  section: 'programme',
  eyebrow: 'Soins',
  title: 'Programme opératoire',
  tint: { current: 'bg-violet-600 text-white', idle: 'bg-violet-50 text-violet-700' },
  types: { options: TYPE_OPTIONS, of: typeOf, label: typeLabel, otherPlaceholder: 'ex. Programme spécial pédiatrie' },
  words: {
    one: 'programme',
    many: 'programmes',
    add: 'Ajouter un programme',
    editTitle: 'Modifier le programme',
    deleteTitle: 'Supprimer le programme',
    fallbackName: 'Programme opératoire',
    titleHint: 'Facultatif, par exemple « Programme de la semaine ».',
    searchPlaceholder: 'Intitulé, date, type, document…',
    searchLabel: 'Rechercher un programme',
    loading: 'Chargement des programmes…',
    unavailable: 'Programmes indisponibles',
    emptyUpcoming: 'Aucun programme à venir',
    emptyPast: 'Aucun programme passé',
    emptyUndated: 'Aucun programme sans date',
    upcomingHint: 'Les prochains programmes du bloc apparaîtront ici.',
    noMatch: 'Aucun programme ne correspond à cette recherche.',
    missingDate: 'Indiquez la date du programme.',
    added: 'Programme ajouté.',
    updated: 'Programme mis à jour.',
    deleted: 'Programme supprimé.',
    saveFailed: 'Le programme n’a pas pu être enregistré. Vérifiez la connexion, puis réessayez.',
    deleteFailed: 'Le programme n’a pas pu être supprimé.',
  },
};

const ProgrammePage = () => <SchedulePage config={PROGRAMME} />;

export default ProgrammePage;
